import * as actionTypes from "./actionTypes";
import { LOGOUT_USER } from "../user/actionTypes";

const initialState = {
    franchiseBilling: { pdf_link: null, error: null, loading: false },
    activeFranchiseBilling: { franchiseBilling: null, error: null, loading: false },
};

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FRANCHISE_BILLING:
            return { ...state, franchiseBilling: { pdf_link: null, error: null, loading: true } }

        case actionTypes.FRANCHISE_BILLING_SUCCESS:
            return { ...state, franchiseBilling: { pdf_link: action.payload.pdf_link, error: null, loading: false } }

        case actionTypes.FRANCHISE_BILLING_FAILURE:
            return { ...state, franchiseBilling: { pdf_link: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_FRANCHISE_BILLING:
            return { ...state, franchiseBilling: initialState.franchiseBilling }


        case actionTypes.ACTIVE_FRANCHISE_BILLING:
            return { ...state, activeFranchiseBilling: { franchiseBilling: null, error: null, loading: true } }

        case actionTypes.ACTIVE_FRANCHISE_BILLING_SUCCESS:
            return { ...state, activeFranchiseBilling: { franchiseBilling: action.payload.franchiseBilling, error: null, loading: false } }

        case actionTypes.ACTIVE_FRANCHISE_BILLING_FAILURE:
            return { ...state, activeFranchiseBilling: { franchiseBilling: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_ACTIVE_FRANCHISE_BILLING:
            return { ...state, activeFranchiseBilling: initialState.activeFranchiseBilling }

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/franchise/reducer.js